const formatCurrency = (value) =>
  new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency: "EUR",
  }).format(Number(value || 0));

const formatPeriodLabel = (period) => {
  if (!period) return "Unknown period";
  const [year, month] = String(period).split("-");
  if (!year || !month) return period;
  const parsed = new Date(Number(year), Number(month) - 1, 1);
  return new Intl.DateTimeFormat("en-GB", { month: "short", year: "numeric" }).format(parsed);
};

export const buildMembershipPaymentHistoryViewModel = (rows = []) =>
  (rows || [])
    .map((row) => {
        const status = String(row?.status || "pending").trim().toLowerCase();
        const isPaid = status === "paid" || status === "succeeded" || status === "success";
        const failureReasonRaw = String(row?.failure_reason || "").trim();
        const isFailed =
          status.includes("fail") ||
          status === "insufficient_funds" ||
          failureReasonRaw.length > 0;
      const statusLabel = isPaid ? "Paid" : isFailed ? "Failed" : "Pending";
      const settlementLabel = isPaid ? "Completed" : isFailed ? "Needs action" : "Pending";
      const canRetry = isFailed;
      const failureReason = String(row?.failure_reason || "").trim().toLowerCase();
      const failureLabel =
        failureReason === "insufficient_funds"
          ? "Insufficient funds"
          : failureReason
            ? failureReason.replace(/_/g, " ")
            : "Payment failed";
      return {
        id: row?.id || `${row?.period || "period"}-${row?.status || "status"}`,
        period: row?.period || null,
        periodLabel: formatPeriodLabel(row?.period),
        status,
        statusLabel,
        settlementLabel,
        amount: Number(row?.amount_eur || 0),
        amountLabel: formatCurrency(row?.amount_eur || 0),
        canRetry,
        failureReason,
        failureLabel,
        paymentId: row?.payment_id || null,
        paymentUrl: row?.payment_url || null,
      };
    })
    .sort((a, b) => String(b.period || "").localeCompare(String(a.period || "")));
